import PageContainer from "shared/components/pagecontainer/PageContainer";
import styles from "./ProdutoCadastrado.module.scss";
import { CheckCircle } from "lucide-react";
import {
  useNavigate,
  useLocation,
} from "react-router-dom";

export const ProdutoCadastrado = () => {

  const navigate =
    useNavigate();

  const location =
    useLocation();

  const produto =
    location.state?.produto;

  return (

    <PageContainer title="Produto Cadastrado">

      <div className={styles.container}>

        <CheckCircle
          size={56}
          className={styles.icon}
        />
        <div className={styles.divLabel}>
          <h2>
          Produto cadastrado com sucesso!
        </h2>

        <p>
          {produto
            ? `"${produto}" já está disponível na sua loja.`
            : "Seu produto já está disponível na sua loja."
          }
        </p>
        </div>
        

        <div className={styles.actions}>

          <button
            className={styles.btnPrimary}
            onClick={() =>
              navigate("/meusprodutos")
            }
          >
            Ir para Meus Produtos
          </button>

          <button
            className={styles.btnSecondary}
            onClick={() =>
              navigate("/cadastroproduto")
            }
          >
            Cadastrar Novo Produto
          </button>

        </div>

      </div>

    </PageContainer>
  );
};